import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

/**
 * Interface para as propriedades do componente SEO.
 * @param titleKey - A chave da tradução para o título (ex: "seo.title")
 * @param descriptionKey - A chave da tradução para a meta description
 * @param args - Objeto opcional com variáveis para substituir no texto (ex: { appName: "Dropi" })
 */
interface SEOProps {
  titleKey: string;
  descriptionKey: string;
  args?: Record<string, string | number>;
}

const SEO: React.FC<SEOProps> = ({ titleKey, descriptionKey, args }) => {
  const { t, i18n } = useTranslation();

  // Obtemos as strings traduzidas
  const title: string = t(titleKey, args);
  const description: string = t(descriptionKey, args);
  const seo_url: string = t("seo_url");

  return (
    <Helmet>
      {/* Atributo de idioma no HTML ajuda tecnologias assistivas e SEO local */}
      <html lang={i18n.language} />

      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content="%PUBLIC_URL%/banner.jpg" />
      <meta property="og:url" content={seo_url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={title} />
    </Helmet>
  );
};

export default SEO;
